export function getDepositInfo(state) {
  return state.depositInfo;
}